import React, { useState } from "react"
import Layout from "../components/layout"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Img from "gatsby-image" // to take image data and render it
import Lightbox from "react-image-lightbox"
import "react-image-lightbox/style.css" // This only needs to be imported once in your app
import paintingInventoryIndexStr from "../../resources/Painting Inventory_Image List - Sheet1.tsv"
import styled from "styled-components"
import usePositionFooter from "../util/position-footer"

const paintingInventoryIndex = createImageIndex(
  parsePaintingInventoryList(paintingInventoryIndexStr)
)

const numCols = 4

function parsePaintingInventoryList(tsvStr) {
  const lines = tsvStr.split("\n").map(lineStr => lineStr.split("\t"))
  const headers = lines[0].map(header => header.trim())
  const rows = lines.slice(1).map((line, i) => {
    const o = { rowIndex: i }
    line.forEach((value, j) => (o[headers[j]] = value.trim()))
    return o
  })
  return rows
}

function chunkArray(array, chunkSize) {
  return [].concat.apply(
    [],
    array.map(function (elem, i) {
      return i % chunkSize ? [] : [array.slice(i, i + chunkSize)]
    })
  )
}

const TextOverlay = styled.div`
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none
  background-color: rgba(255,255,255,0);
  opacity:0;
  transition: background-color 300ms ease-in-out, opacity 300ms ease-in-out;

  :hover {
    background-color: rgba(255,255,255,.75);
    opacity:1;
  }
`

function createImageIndex(paintingInventoryList) {
  const index = {}
  paintingInventoryList.forEach(o => {
    let nameOfFile = o["Name of File & Link"]
    if (!nameOfFile) return
    let tmp = nameOfFile.split(".")
    let lastComponentLength = tmp[tmp.length - 1].length
    if (
      tmp.length > 1 &&
      (lastComponentLength === 3 || lastComponentLength === 4)
    ) {
      nameOfFile = tmp.slice(0, -1).join(".")
    }
    index[nameOfFile.toLowerCase()] = o
  })
  return index
}

function lookupImageMetadata(imgData){
  return imgData && paintingInventoryIndex[imgData.node.name.toLowerCase()];
}

const getAltText = selectedPhotoData =>
  selectedPhotoData
    ? `${selectedPhotoData["Public Title"]}, ${selectedPhotoData["Year"]}, ${selectedPhotoData["Material"]}, ${selectedPhotoData["Size"]}`
    : ""

export default function PaintingsGallery({ data, location }) {
  const [photoIndex, setPhotoIndex] = useState(null)
  const images = data.allFile.edges
    .filter(edge => edge.node.childImageSharp && paintingInventoryIndex[edge.node.name.toLowerCase()])
    .sort((a,b) => lookupImageMetadata(a).rowIndex - lookupImageMetadata(b).rowIndex);
  const selectedPhotoData =
    photoIndex !== null && lookupImageMetadata(images[photoIndex])

  const [copyrightFooterRef, runAfterImagesLoaded] = usePositionFooter(location)

  return (
    <Layout location={location} ref={copyrightFooterRef}>
      {chunkArray(images, numCols).map((row, i) => (
        <Row key={i}>
          {[...Array(numCols).keys()].map(j => {
            const imgData = row[j]
            const foundRow = imgData && lookupImageMetadata(imgData)
            return (
              <Col
                sm={true}
                key={j}
                style={{ margin: "3em", padding: 0 }}
                onClick={() => setPhotoIndex(i * numCols + j)}
              >
                <TextOverlay>
                  <table style={{ width: "100%", height: "100%" }}>
                    <tbody>
                      <tr>
                        {foundRow && (
                          <td style={{ valign: "middle", align: "center" }}>
                            <div style={{ textAlign: "center" }}>
                              {foundRow["Public Title"]}
                            </div>
                            <div style={{ textAlign: "center" }}>
                              {foundRow["Year"]}
                            </div>
                            <div style={{ textAlign: "center" }}>
                              {foundRow["Material"]}
                            </div>
                            <div style={{ textAlign: "center" }}>
                              {foundRow["Size"]}
                            </div>
                          </td>
                        )}
                      </tr>
                    </tbody>
                  </table>
                </TextOverlay>
                {imgData && (
                  <Img
                    onLoad={runAfterImagesLoaded}
                    alt={getAltText(foundRow)}
                    key={imgData.node.id}
                    fluid={imgData.node.childImageSharp.thumbnail}
                  />
                )}
              </Col>
            )
          })}
        </Row>
      ))}
      {photoIndex !== null && (
        <Lightbox
          mainSrc={images[photoIndex].node.childImageSharp.fluid.src}
          nextSrc={
            images[(photoIndex + 1) % images.length].node.childImageSharp.fluid
              .src
          }
          prevSrc={
            images[(photoIndex + images.length - 1) % images.length].node
              .childImageSharp.fluid.src
          }
          onCloseRequest={() => setPhotoIndex(null)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % images.length)
          }
          imageCaption={getAltText(selectedPhotoData)}
        />
      )}
    </Layout>
  )
}
